// MarkersPage.tsx — `/markers`: what the QR sizing markers are, the payload
// format (ARCHITECTURE.md §3), and how to print a sheet at true scale with
// the markers generator.
import Table from 'react-bootstrap/Table';
import { CopyBlock } from '../components/CopyBlock';

const PRINT_CMD = 'bazel run //products/openscan/markers:generate -- --size 40mm --count 12 --paper a4 --print';

export default function MarkersPage() {
  return (
    <>
      <h1 className="h3 mb-3">Sizing Markers</h1>
      <div className="prose-column mb-4">
        <p>
          openscan gets its <strong>metric scale</strong> from printed QR codes laid flat around the object. Each code
          states its own printed size, so the scanner knows exactly how big the world is, where the floor plane is, and
          enough about the lens to calibrate the phone camera on the fly.
        </p>
        <p>
          The lowest-numbered marker seen first becomes the origin: <strong>+X</strong> runs along its top edge,{' '}
          <strong>+Y</strong> toward its top, and <strong>Z</strong> points up off the table. Use 4–8 markers spread around
          the object, keep them flat, and don&apos;t move them during a scan.
        </p>
      </div>

      <div className="card-grid mb-4">
        <CopyBlock
          title="Print a Sheet"
          text={PRINT_CMD}
          caption="Prints at 100% / actual size. Check the 100 mm ruler on the page with a real ruler before scanning; --out markers.pdf writes the PDF instead."
        />
        <CopyBlock
          title="Payload Format"
          text={'text/marker;size=40mm;id=7'}
          caption="size is the edge length of the dark modules (quiet zone excluded) in mm, cm or in; id defaults to 0. Any other QR code in view is ignored."
        />
      </div>

      <h2 className="h5">Generator Options</h2>
      <Table size="sm" hover responsive>
        <thead>
          <tr>
            <th>Flag</th>
            <th>Meaning</th>
          </tr>
        </thead>
        <tbody>
          <tr><td><code>--size 40mm</code></td><td>Printed marker edge (mm, cm or in)</td></tr>
          <tr><td><code>--count 12</code></td><td>Markers on the sheet</td></tr>
          <tr><td><code>--start-id 0</code> / <code>--ids 3,4,9</code></td><td>Which marker ids to print</td></tr>
          <tr><td><code>--paper a4|letter</code></td><td>Sheet size</td></tr>
          <tr><td><code>--out markers.pdf</code></td><td>Write the PDF to a file</td></tr>
          <tr><td><code>--print --printer NAME --copies N</code></td><td>Send straight to a printer via lp at 100% scale</td></tr>
        </tbody>
      </Table>
    </>
  );
}
